// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
};

// Project Gallery
export const GALLERY = {
  TOTAL_IMAGES: 24,
  IMAGES_PER_ROW_DESKTOP: 4,
  IMAGES_PER_ROW_TABLET: 3,
  IMAGES_PER_ROW_MOBILE: 2,
  MAX_DISPLAY_COUNT: 12
};

// Form Validation
export const VALIDATION = {
  PHONE_MIN_LENGTH: 10,
  PHONE_MAX_LENGTH: 15,
  NAME_MIN_LENGTH: 2,
  MESSAGE_MIN_LENGTH: 10
};

// WhatsApp
export const WHATSAPP = {
  PHONE_NUMBER: "447780996775",
  BASE_URL: "https://wa.me"
};

// Business Info
export const BUSINESS = {
  PHONE: "07780 996775",
  PHONE_INTERNATIONAL: "+447780996775",
  SERVICE_AREAS: ["Surrey", "SW London"],
  YEARS_EXPERIENCE: "10+"
};
